import { render, staticRenderFns } from "./Valves.vue?vue&type=template&id=1ac4d48a"
import script from "./Valves.vue?vue&type=script&lang=js"
export * from "./Valves.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports